import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DobryAgentBlogTagService} from "../../../../shared/services/dobry-agent-blog-tag.service";
import {takeUntil} from "rxjs/operators";
import {DobryAgentBlogTag} from "../../../../shared/interface/dobry-agent-blog-article";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {AuthService} from "../../../../shared/services/auth.service";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-da-tag-details',
  templateUrl: './da-tag-details.component.html',
  styleUrls: ['./da-tag-details.component.scss']
})
export class DaTagDetailsComponent implements OnInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  tagId?: string;
  loading = false;
  modify = false;
  userPermissions: ReplaySubject<UserPermissions>;
  blogTagObject?: DobryAgentBlogTag;
  blogTag: ReplaySubject<DobryAgentBlogTag> = new ReplaySubject<DobryAgentBlogTag>(1);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private blogTagService: DobryAgentBlogTagService,
    private auth: AuthService,
    private snack: MatSnackBar,

  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.tagId = params.id;
        this.load();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  load(): void {
    this.blogTagService.get(this.tagId).subscribe((tag: DobryAgentBlogTag) => {
      this.blogTag.next(tag);
      this.blogTagObject = tag;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych ', error.status.toString(), {
        duration: 2000
      });
      this.router.navigate(['/blog-dobry-agent/tagi']);
    });
  }

}
